import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import {
  MY_PATH_URL,
  NEW_PLAN,
  buildPathsChatUrl,
  isPathsId,
} from '../../features/paths/utils/pathsChatUrl';

// There are no /paths pages any more: Paths lives in /chat. These redirects
// keep old links and bookmarks working, and are the only place /paths still
// appears. router.js maps this table, and PathsRedirect.test.js mounts the
// same table, so the test covers the real redirects.
//
// An id that is not a plain id (see isPathsId) falls back to My Path rather
// than being passed into /chat.

const idOr = (value, fallback) => (isPathsId(value) ? value : fallback);

export const PATHS_REDIRECTS = [
  { path: '/paths', to: () => MY_PATH_URL },
  { path: '/paths/plan', to: () => buildPathsChatUrl({ planSessionId: NEW_PLAN }) },
  {
    path: '/paths/plan/:sessionId',
    to: ({ sessionId }) => (isPathsId(sessionId) ? buildPathsChatUrl({ planSessionId: sessionId }) : MY_PATH_URL),
  },
  {
    path: '/paths/:id/revise',
    to: ({ id }) => (isPathsId(id) ? buildPathsChatUrl({ pathId: id, planSessionId: NEW_PLAN }) : MY_PATH_URL),
  },
  {
    path: '/paths/:id/revise/:sessionId',
    to: ({ id, sessionId }) => (isPathsId(id)
      ? buildPathsChatUrl({ pathId: id, planSessionId: idOr(sessionId, NEW_PLAN) })
      : MY_PATH_URL),
  },
  {
    path: '/paths/:id',
    to: ({ id }) => (isPathsId(id) ? buildPathsChatUrl({ pathId: id }) : MY_PATH_URL),
  },
  // The My Path app tile and login intent used to point here; it never had a route.
  { path: '/my-path', to: () => MY_PATH_URL },
];

export default function PathsRedirect({ to }) {
  const params = useParams();
  return <Navigate to={to(params)} replace />;
}
